if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.isOpen = false;
        this.init();
      }

      init() {
        this.bindEventHandlers();
      }

      bindEventListeners() {
        this.updateModalOnVariantChange =
          this.updateModalOnVariantChange.bind(this);
        eventBus.on("variant:updated", this.updateModalOnVariantChange);
      }

      disconnectedCallback() {
        eventBus.off("variant:updated", this.updateModalOnVariantChange);
      }

      hide() {
        super.hide();
        this.isOpen = false;
      }

      show(opener) {
        super.show(opener);
        this.isOpen = true;
        this.showActiveMedia();
      }

      updateModalOnVariantChange(event) {
        /* ===== Update the modal content when a variant changes ===== */
        console.log("Modal received variant:updated event:", event);
        const { variant, sectionId, fetchURL } = event;

        // Only update if this modal is for the current section
        console.log("Modal ID:", this.id);
        console.log("Looking for section ID:", sectionId);

        // Extract the section ID from the modal ID (ProductModal-{sectionId})
        const modalSectionId = this.id.replace("ProductModal-", "");
        console.log("Modal section ID:", modalSectionId);
        console.log("Event section ID:", sectionId);

        // The sectionId from the event is the product ID, not the section ID
        // We need to find the product-information component and get its original-section-id
        const productInfo = document.querySelector(
          `product-information[data-section-id="${sectionId}"]`
        );
        if (!productInfo) {
          console.warn(
            "Product info component not found for section ID:",
            sectionId
          );
          return;
        }

        const originalSectionId = productInfo.getAttribute(
          "data-original-section-id"
        );
        console.log("Original section ID:", originalSectionId);

        // Check if this modal matches the original section ID
        if (modalSectionId !== originalSectionId) {
          console.log("Modal section ID mismatch, not updating");
          return;
        }

        // We already have the productInfo from above, just check if it has a cache
        if (!productInfo.dataCache) {
          console.warn("Product info component has no data cache");
          return;
        }

        // Use the fetchURL from the event
        if (!fetchURL) return;

        // Get the cached data for this variant
        console.log("Looking for cached data with fetchURL:", fetchURL);
        console.log(
          "Available cache keys:",
          Array.from(productInfo.dataCache.keys())
        );
        const cachedData = productInfo.dataCache.get(fetchURL);
        if (!cachedData) {
          console.warn("No cached data found for fetchURL:", fetchURL);
          return;
        }
        console.log("Found cached data:", cachedData);

        // Parse the cached HTML
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(cachedData, "text/html");
        console.log("Parsed HTML document:", htmlDoc);

        // Find the media-gallery in the cached data
        const newMediaGallery = htmlDoc.querySelector("media-gallery");
        if (!newMediaGallery) {
          console.warn("No media-gallery found in cached data");
          console.log(
            "Available elements in cached data:",
            htmlDoc.querySelectorAll("*")
          );
          return;
        }
        console.log("Found media-gallery in cached data:", newMediaGallery);

        // Find the modal content container
        const modalContent = this.querySelector('[role="document"]');
        if (!modalContent) return;

        // Update the modal content with the new media gallery
        // We need to preserve the modal structure but update the media content
        this.updateModalMediaContent(newMediaGallery);
      }

      updateModalMediaContent(newMediaGallery) {
        /* ===== Update the modal's media content with new variant data ===== */
        console.log(
          "Updating modal content with new media gallery:",
          newMediaGallery
        );

        // Find the modal content container
        const modalContent = this.querySelector('[role="document"]');
        if (!modalContent) {
          console.warn("Modal content container not found");
          return;
        }

        console.log("Modal content container found:", modalContent);

        // Extract the media items from the media-gallery
        const mediaItems = newMediaGallery.querySelectorAll(
          ".product__media-item"
        );
        console.log("Found media items:", mediaItems.length);

        if (mediaItems.length === 0) {
          console.warn("No media items found in the new media gallery");
          return;
        }

        // Clear existing modal content
        const existingContent = modalContent.querySelector(
          ".product-media-modal__content"
        );
        if (existingContent) {
          existingContent.innerHTML = "";
        }

        // Create new modal content with the new variant's media
        mediaItems.forEach((mediaItem, index) => {
          // Clone the media item
          const clonedMediaItem = mediaItem.cloneNode(true);

          // Create a product-media wrapper for this item
          const productMediaWrapper = document.createElement("div");
          productMediaWrapper.className = "product-media-item";

          // Extract the media content and create a product-media structure
          const mediaContent =
            this.createProductMediaFromMediaItem(clonedMediaItem);
          if (mediaContent) {
            productMediaWrapper.appendChild(mediaContent);
            existingContent.appendChild(productMediaWrapper);
          }
        });

        console.log("Modal content updated with new variant media");

        // Reinitialize any necessary functionality for the new content
        this.initializeModalMedia();

        // If the modal is currently open, update the active media display
        if (this.isOpen) {
          this.showActiveMedia();
        }
      }

      createProductMediaFromMediaItem(mediaItem) {
        /* ===== Convert a media-gallery item to product-media structure ===== */
        try {
          // Extract the media ID and type
          const mediaId = mediaItem.getAttribute("data-media-id");
          const mediaType = mediaItem.getAttribute("data-media-type");

          // Find the image or media content
          const mediaContent = mediaItem.querySelector(
            "img, video, .deferred-media"
          );
          if (!mediaContent) {
            console.warn(`No media content found for item ${mediaId}`);
            return null;
          }

          // Create a product-media structure
          const productMedia = document.createElement("div");
          productMedia.className = "product-media";
          productMedia.setAttribute("data-media-id", mediaId);
          productMedia.setAttribute("data-media-type", mediaType);

          // Clone the media content
          const clonedContent = mediaContent.cloneNode(true);
          productMedia.appendChild(clonedContent);

          return productMedia;
        } catch (error) {
          console.error("Error creating product-media from media item:", error);
          return null;
        }
      }

      initializeModalMedia() {
        /* ===== Initialize any necessary functionality for the modal media ===== */
        // This method can be used to reinitialize any media-related functionality
        // such as swipers, lightboxes, etc.
        console.log("Initializing modal media functionality");
      }

      showActiveMedia() {
        // Check if openedBy exists and has the required attribute
        if (!this.openedBy || !this.openedBy.getAttribute("data-media-id")) {
          console.warn("Modal openedBy element or data-media-id not found");
          return;
        }

        const mediaId = this.openedBy.getAttribute("data-media-id");

        // Find all media elements and remove active class
        this.querySelectorAll("[data-media-id]").forEach((element) => {
          element.classList.remove("active");
        });

        // Find the active media element
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) {
          console.warn(`Media element with ID ${mediaId} not found in modal`);
          return;
        }

        // Add active class and scroll into view
        activeMedia.classList.add("active");
        activeMedia.scrollIntoView();

        // Handle template content if it exists
        const activeMediaTemplate = activeMedia.querySelector("template");
        if (activeMediaTemplate) {
          const activeMediaContent = activeMediaTemplate.content;

          // Handle deferred media (videos, 3D models, etc.)
          if (
            activeMedia.nodeName == "DEFERRED-MEDIA" &&
            activeMediaContent &&
            activeMediaContent.querySelector(".js-youtube")
          ) {
            activeMedia.loadContent();
          }
        }

        // Center the active media in the container
        const container = this.querySelector('[role="document"]');
        if (container && activeMedia.width) {
          container.scrollLeft =
            (activeMedia.width - container.clientWidth) / 2;
        }
      }
    }
  );
}
